import script from "./columnBand.vue?vue&type=script&lang=js"
export * from "./columnBand.vue?vue&type=script&lang=js"

import "./columnBand.vue?vue&type=style&index=0&id=2d919152&lang=scss"

const __exports__ = script;

export default __exports__